import { render, staticRenderFns } from "./TheFormAddressesCart.vue?vue&type=template&id=4639ce6f&scoped=true&"
import script from "./TheFormAddressesCart.vue?vue&type=script&lang=ts&"
export * from "./TheFormAddressesCart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4639ce6f",
  null
  
)

export default component.exports